import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type UpdateSwFn = (reloadPage?: boolean) => Promise<void>;

interface SwState {
  needRefresh: boolean;
  offlineReady: boolean;
  isUpdating: boolean;
  dismissed: boolean;
  registration: ServiceWorkerRegistration | null;

  // Internal — set by main.tsx after registerSW returns
  _updateFn: UpdateSwFn | null;
  _setUpdateFn: (fn: UpdateSwFn) => void;

  setNeedRefresh: (v: boolean) => void;
  setOfflineReady: (v: boolean) => void;
  setRegistration: (reg: ServiceWorkerRegistration) => void;
  dismiss: () => void;
  updateApp: () => Promise<void>;
  reset: () => void;
}

export const useSwStore = create<SwState>()(devtools((set, get) => ({
  needRefresh: false,
  offlineReady: false,
  isUpdating: false,
  dismissed: false,
  registration: null,
  _updateFn: null,

  _setUpdateFn: (fn) => set({ _updateFn: fn }),

  setNeedRefresh: (v) => set({ needRefresh: v, dismissed: false }),
  setOfflineReady: (v) => set({ offlineReady: v }),
  setRegistration: (reg) => set({ registration: reg }),
  dismiss: () => set({ dismissed: true }),

  updateApp: async () => {
    const fn = get()._updateFn;
    if (!fn) return;
    set({ isUpdating: true });
    try {
      await fn(true); // triggers skipWaiting + reload
    } catch {
      set({ isUpdating: false });
    }
  },

  reset: () => set({
    needRefresh: false,
    offlineReady: false,
    isUpdating: false,
    dismissed: false,
    registration: null,
    _updateFn: null,
  }),
}), { name: 'sw-store' }));
